let startFn = () => {};
let completeFn = () => {};

export const setLoadingBarMethods = (start, complete) => {
    startFn = start;
    completeFn = complete;
};

export const startLoading = () => startFn();
export const completeLoading = () => completeFn();
